import { render, staticRenderFns } from "./AdjustInvoiceVAT.vue?vue&type=template&id=668b5f12"
import script from "./AdjustInvoiceVAT.vue?vue&type=script&lang=js"
export * from "./AdjustInvoiceVAT.vue?vue&type=script&lang=js"
import style0 from "./AdjustInvoiceVAT.vue?vue&type=style&index=0&id=668b5f12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports